import * as React from "react";
import { Container, Grid, Paper } from "@material-ui/core";
import { useState } from "react";
import { useVerifyPermission } from "@airborne/react-admin";
import ThyFailOnFitList from "./ThyFailOnFitList";
import ThyFailOnFitFilter from "./ThyFailOnFitFilter";
import ThyFailOnFitTrend from "./ThyFailOnFitTrend";
import ThyFailOnFitRateSource from "./ThyFailOnFitRateSource";

const ThyFailOnFit = props => {
  useVerifyPermission("customroutes", "thyfailonfit.read");

  const now = new Date();
  const [filterParams, setFilterParams] = useState({
    startDate: new Date(new Date().setMonth(now.getMonth() - 1)),
    endDate: now,
  });

  const CreateFilter = filterParams => {
    var filter = {
      createdDate__gte: filterParams.startDate,
      createdDate__lte: filterParams.endDate,
    };

    if (filterParams?.fleetType) {
      filter = { ...filter, ...{ fleetType__eq: filterParams?.fleetType } };
    }
    if (filterParams?.acType) {
      filter = { ...filter, ...{ acType__eq: filterParams?.acType } };
    }

    return filter;
  };

  return (
    <>
      <ThyFailOnFitFilter filterParams={filterParams} setFilterParams={setFilterParams} />
      <br />
      <Container maxWidth="xl">
        <Paper variant="outlined">
          <Grid container direction="row" justifyContent="center" alignItems="center">
            <Grid item>
              <ThyFailOnFitTrend filterParams={CreateFilter(filterParams)} />
            </Grid>
          </Grid>
        </Paper>
      </Container>
      <Container maxWidth="xl">
        <Paper variant="outlined">
          <ThyFailOnFitRateSource filterParams={CreateFilter(filterParams)} />
        </Paper>
      </Container>
      <br />
      <Container maxWidth="xl">
        <Paper elevation={2} variant="outlined">
          <ThyFailOnFitList basePath="reliabilitythyfailonfits" filterParams={CreateFilter(filterParams)} {...props} />
        </Paper>
      </Container>
    </>
  );
};

export default ThyFailOnFit;
